import { calculateServerIndexFromAvailableServers } from '@genially/p2p-lib';

import { env } from '../config/env';
import { P2pRestClient } from '../services/P2pRestClient';

export class UnavailableServerError extends Error {}

const calculateServerIndexWithAvailableServers = async (
  value: string,
): Promise<number> => {
  const availableServers = await P2pRestClient.getAvailableServers();

  if (availableServers === 0 && env.isProduction) {
    throw new UnavailableServerError('No servers available');
  }

  return calculateServerIndexFromAvailableServers({
    valueToHash: value,
    availableServers,
  });
};

let lastCalculation: { time: number; value: number } | undefined;

/**
 * Get the server index for a given value
 * The value will be cached for 3 seconds to prevent DDoS
 * @param value
 */
export const calculateServerIndex = async (
  value: string,
  options?: { force: boolean },
): Promise<number> => {
  if (!options?.force) {
    if (lastCalculation && Date.now() - lastCalculation.time < 3000) {
      return Promise.resolve(lastCalculation.value);
    }
  }

  const serverIndex = await calculateServerIndexWithAvailableServers(value);

  lastCalculation = { time: Date.now(), value: serverIndex };

  return Promise.resolve(serverIndex);
};
